import React, { useEffect, useState, FC } from "react";
import { GetStroreRequisitionDetail } from "../../api/storeRequisition";
import { useGlobalState } from "../../context/Provider";
import { datahelper, columns } from "../../helpers/history.helper";
import { Table } from "antd";
import "../productInventory/productInventory.style.scss";
interface StoreRequisitionDetailIprops {
  id: number;
}
const StoreRequisitionDetail: FC<StoreRequisitionDetailIprops> = (props) => {
  const { id } = props;
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { langState, warehouserList }: any = useGlobalState();
  const lang = langState.locale;

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = () => {
    GetStroreRequisitionDetail(id).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(datahelper(res.data.history, 1));
      }
    });
  };

  return (
    <Table
      className="tableProductInventroy"
      columns={columns(lang, warehouserList.data)}
      dataSource={data}
      size="middle"
      pagination={false}
      scroll={{ x: 1100 }}
      loading={loading}
    />
  );
};

export default StoreRequisitionDetail;
